export const aciUpgradeSports = {
    iconName: 'upgrade-sports',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 24 24' },
        path: {
            attr: {
                d: 'M13.109 11.395l-1.04.242c-.16 0-.32.162-.32.323l-.24 1.291c-.08.646-.72 1.13-1.36.969-.64-.08-1.12-.726-.96-1.372l.24-1.292c.16-1.13 1.04-2.098 2.24-2.34 4.56-.888 2.88-1.05 5.92 1.372.16.08.32.161.4.08l1.44-.726c.56-.323 1.28-.08 1.6.565.32.565.08 1.292-.56 1.614l-1.44.727c-.4.161-.8.323-1.28.323-.64 0-1.28-.242-1.84-.646l-.48-.404-.56 2.018 1.44.485c.72.322 1.28.887 1.52 1.614.24.726.24 1.533-.08 2.18l-.4 1.048c-.16.485-.64.727-1.12.727-.16 0-.32 0-.48-.08-.64-.243-.88-.97-.64-1.615l.48-1.13c.16-.265.068-.555-.16-.646l-1.52-.565-2.48 4.278c-.24.404-.64.565-1.04.565-.24 0-.4-.08-.64-.162-.56-.322-.8-1.049-.4-1.694l1.92-3.31M7.15 7.902H3.17M7.15 11.918H4.364M7.15 15.935H5.956M16.542 7.843a2.41 2.41 0 01-2.4-2.422A2.41 2.41 0 0116.542 3a2.41 2.41 0 012.4 2.421 2.41 2.41 0 01-2.4 2.422z',
                stroke: 'currentColor',
                'stroke-width': '1.2',
                'stroke-miterlimit': '10',
                'stroke-linecap': 'round',
                'stroke-linejoin': 'round',
            },
        },
    },
};
